import React, { useCallback } from 'react'
import { Stack } from '@material-ui/core'
import AnalysisPopover from '../AnalysisPopover'
import AnnotateButton from './AnnotateButton'
import { getStatusLabel } from '../utils/fileUtils'

const AnalysisDisplay = React.memo(({ row, annotationStatus, onAnnotate }) => {
  const status = getStatusLabel(row)
  const id = row.vcf_id || row.fastq_pair_id

  const handleAnnotate = useCallback(() => {
    onAnnotate(row)
  }, [onAnnotate, row])

  if (!status) return null

  if (status === 'DONE' || status === 'PENDING') {
    return <AnalysisPopover fileId={id} sampleName={row.sample_name} />
  }

  if (
    status.includes('RUNNING') ||
    status.includes('VERIFYING') ||
    status.includes('SINGLE_FASTQ') ||
    status.includes('NOT_VERIFIED') ||
    status.includes('FAILED')
  ) {
    return null
  }

  return (
    <Stack direction="row" spacing={1}>
      <AnnotateButton onClick={handleAnnotate} status={annotationStatus[id] || 'idle'} />
    </Stack>
  )
})

AnalysisDisplay.displayName = 'AnalysisDisplay'

export default AnalysisDisplay
